export default __webpack_public_path__ + "static/media/Listen.858df5ce.mov";